import React, { useState } from "react";
import { Space } from "antd";
import { Check, Printer } from "@phosphor-icons/react";
import ToolbarLayout from "./ToolbarLayout";
import { ButtonCommon as Button } from "../Button/ButtonCommon";
import ConfirmationModal from "../Modal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { StatusCode } from "types/status.types";

const ToolbarViewContainerDetail: React.FC<{
  title: string;
  statusCode?: StatusCode | string;
  onUpdateStatus?: (targetStatus: StatusCode) => void;
  isUpdating?: boolean;
}> = ({
  title,
  statusCode,
  onUpdateStatus,
  isUpdating,
}) => {
  const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
  const navigate = useNavigate();

  const handleConfirmCancel = () => {
    setIsOpenCancelModal(false);
    navigate(-1); // quay lại trang trước
  };

  /** Left Section */
  const left = (
    <Space align="center" className="gap-[24px] flex-wrap items-center">
      <div className="flex flex-col gap-[8px]">
        <p className="text-[20px] font-bold text-[var(--textBlack100)]">
         {title}
        </p>
        <p className="text-[14px] text-[var(--textBlack56)]">
          Tất cả thông tin chi tiết của một lệnh đã được hiển thị đầy đủ bên dưới, bạn chỉ có thể chỉnh sửa một vài giá trị
        </p>
      </div>
    </Space>
  );

  /** Right Section */
  const right = (
    <Space align="center" className="gap-1 flex-wrap items-center">
      <div className="flex gap-3">
        <Button
          color="soft"
          radius="rounded"
          className="flex justify-center items-center"
        >
          <Printer size={20} className="mr-2" />
          In tệp tin
        </Button>
        {(!statusCode || statusCode === StatusCode.DRAFT) && onUpdateStatus && (
          <Button
            color="primary"
            radius="rounded"
            className="flex justify-center items-center"
            onClick={() => onUpdateStatus(StatusCode.CREATED)}
            loading={isUpdating}
            disabled={isUpdating}
          >
            <Check size={20} className="mr-2" />
            Khởi tạo lệnh
          </Button>
        )}
      </div>
      {/* Modal xác nhận */}
      <ConfirmationModal
        isOpen={isOpenCancelModal}
        onCancel={() => setIsOpenCancelModal(false)}
        onConfirm={handleConfirmCancel}
        title="Xác nhận hủy chỉnh sửa"
        subtitle={
          <div>
            Bạn có chắc chắn muốn <b>hủy chỉnh sửa thông tin lệnh</b>{" "}
            không?
          </div>
        }
        icon="warning"
        confirmText="Đồng ý"
        confirmLoading={false}
      />
    </Space>
  );

  return (
    <ToolbarLayout left={left} right={right} className="rounded-lg shadow" />
  );
};

export default ToolbarViewContainerDetail;
